export const ENTER = 'Enter';

export const URL_REGEX = /(https?:\/\/[^\s]+)/g;
export const YOUTUBE_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^\s&]+)/;

export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';

export const STORAGE_VIDEO_KEY = 'continueWatchingVideos';

export const break1 = 10;
export const break2 = 20;
export const break3 = 32;

export const static_video_url =
  'https://player.vimeo.com/video/1099737447?h=0de030f1f0&autoplay=1&app_id=122963';

export const variable_video = 'video';
export const variable_applied = 'applied';
export const variable_combination = 'combination';
export const variable_category = 'category';
export const variable_article = 'article';
